import React from 'react';

import withStyles from '@material-ui/core/styles/withStyles';
import InputBase from '@material-ui/core/InputBase';
import Typography from '@material-ui/core/Typography';

class StyledTextField extends React.Component{
    handleChange = event => {
        const newVal = event.target.value;

        if (this.props.onChange){
            this.props.onChange(newVal);
        }
    };

    render(){
        const { classes } = this.props;

        return(
            <div className={classes.wrapper}>
                { this.props.label ? <Typography className={classes.label}>{this.props.label}</Typography> : null }
                <InputBase
                    value={this.props.value || ''}
                    min={0}
                    step={0.01}
                    placeholder={this.props.placeholder || ''}
                    type={this.props.type || 'text'}
                    rows={this.props.rows || undefined}
                    multiline={this.props.multiline || false}
                    className={classes.input + (this.props.className ? ' ' + this.props.className : '')}
                    onChange={this.handleChange}
                    fullWidth={this.props.fullWidth || false}
                />
            </div>
        )
    }
}

const styles = theme => ({
    wrapper: {
        padding: '0.5rem'
    },
    input: {
        border: '0.25rem solid rgba(0,0,0,0.6)',
        backgroundColor: 'rgba(0,0,0,0.1)',
        color: 'rgba(0,0,0,0.6)',
        padding: '0',
        '& .MuiInputBase-input': {
            padding: '0.3rem',
            fontSize: '1.1rem',
            fontWeight: 'bolder',
            maxWidth: '100%'
        }
    },
    label: {
        fontWeight: 'bold',
        fontSize: '1rem',
        color: 'rgba(0,0,0,0.6)'
    }
});

export default withStyles(styles)(StyledTextField);